<template>
  <div class="go-in">
    <div
      class="organizational"
      :style="`height:${pageLoading ? '3rem' : 'auto'};`"
    >
      <div style="box-sizing: border-box; padding: 0rem 1rem 0rem 1rem">
        <TitleTips
          :routerList="routerList"
          routeType="/gywm/qualityCommitment"
          title="质量承诺"
        />
      </div>
      <div
        calss="organitionImg"
        style="
          display: flex;
          justify-content: center;
          margin-bottom: 0.1rem;
          box-sizing: border-box;
          padding: 0rem 1rem 0rem 1rem;
        "
        v-loading="pageLoading"
      >
        <iframe
          v-if="pdfUrl"
          title="通用协议"
          :src="pdfUrl"
          style="width: 100%; height: 1000px"
          frameBorder="0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from '../components/TitleTips.vue';
import http, { downloadFile } from '../utils/http';
export default {
  components: {
    TitleTips
  },
  name: 'qualityCommitment',
  data() {
    return {
      pageLoading: false,
      imgUrlBanner: '',
      pageObj: {},
      routerList: [],
      pdfUrl: ''
    };
  },
  methods: {},
  created() {
    this.pageLoading = true;
    http
      .post('/reception/about/getAllUs', {
        groupType: '107',
        title: '',
        pageNum: 0,
        pageSize: 100
      })
      .then(res => {
        downloadFile(`/file/download?path=${res.rows[0].url}`)
          .then(blob => {
            var binaryData = [];

            binaryData.push(blob);

            const url = window.URL.createObjectURL(
              new Blob(binaryData, { type: 'application/pdf' })
            );
            const htmlUrl = `${process.env.BASE_URL}pdf/web/viewer.html`;
            const pdfUrl = `${htmlUrl}?file= ${encodeURIComponent(url)}`;
            this.pdfUrl = pdfUrl;
          })
          .finally(() => {
            this.pageLoading = false;
          });
      });
  },
  mounted() {
    this.routerList = this.$route.matched;
  },

  watch: {
    // $route: {
    //   handler: function(val, oldVal){
    //     if(val!=oldVal){
    //     }
    //   },
    //   // 深度观察监听
    //   deep: true
    // }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  .organizational {
    width: 100%;
    box-sizing: border-box;
    .organitionImg {
      width: 100%;
      img {
        // width:;
      }
    }
  }
}
</style>
